import { useMemo } from "react";
import type { UserRole } from "@myapp/contract";
import { PATHS } from "../../routes/paths";
import { useAuthStore } from "../../../features/auth/model/store";
import type { IconProps } from "../../assets/icons/navBar/CalendarIcon";
import CalendarIcon from "../../assets/icons/navBar/CalendarIcon";
import RepairOrdersIcon from "../../assets/icons/navBar/RepairOrdersIcon";
import TimeManagementIcon from "../../assets/icons/navBar/TimeManagementIcon";
import TasksIcon from "../../assets/icons/navBar/TasksIcon";
import RescheduleFollowUpIcon from "../../assets/icons/navBar/RescheduleFollowUpIcon";
import UsersIcon from "../../assets/icons/navBar/UsersIcon";
import React from "react";
import ControllingIcon from "src/app/assets/icons/navBar/ControllingIcon";
import SettingsIcon from "src/app/assets/icons/navBar/SettingsIcon";
import PrivatzeitIcon from "src/app/assets/icons/navBar/PrivatzeitIcon";
import ArbeitszeitReport from "src/app/assets/icons/navBar/ArbeitszeitReport";


export interface NavItem {
  label: string;
  path: string;
  Icon?: React.ComponentType<IconProps>;
  roles?: UserRole[];
}

export const allNavItems: NavItem[] = [
  // WORKER
  { label: "Mein Kalender", path: PATHS.workerCalendar, Icon: CalendarIcon, roles: ["WORKER",] },
  { label: "Privatzeit", path: PATHS.workerPrivatzeit, Icon: PrivatzeitIcon, roles: ["WORKER",] },

  // MANAGER
  { label: "Reparaturaufträge", path: PATHS.workOrderPage, Icon: RepairOrdersIcon, roles: ["MANAGER"] },
  { label: "Kalender", path: PATHS.disposition, Icon: CalendarIcon, roles: ["MANAGER", "DIRECTOR", "SUPERUSER"] },
  { label: "Zeitmanagement", path: PATHS.zeitmanagement, Icon: TimeManagementIcon, roles: ["MANAGER", "DIRECTOR", "SUPERUSER"] },
  { label: "Aufgaben", path: PATHS.aufgaben, Icon: TasksIcon, roles: ["MANAGER"] },
  { label: "Umdisponierung/ Folgetermin", path: PATHS.reschedule, Icon: RescheduleFollowUpIcon, roles: ["MANAGER"] },
  // DIRECTOR / SUPERUSER
  { label: "User-Verwaltung", path: PATHS.users, Icon: UsersIcon, roles: ["DIRECTOR", "SUPERUSER"] },
  { label: "Controlling", path: PATHS.controlling, Icon: ControllingIcon, roles: ["DIRECTOR", "SUPERUSER"] },
  { label: "Arbeitszeit-Report", path: PATHS.arbeitszeitReport, Icon: ArbeitszeitReport, roles: ["DIRECTOR", "SUPERUSER"] },
  { label: "Einstellungen", path: PATHS.settings, Icon: SettingsIcon, roles: ["SUPERUSER"] },


];

export function useNavItems(): NavItem[] {
  const roles = useAuthStore((s) => s.user?.roles ?? []);
  return useMemo(
    () => allNavItems.filter((item) => !item.roles || item.roles.some((r) => roles.includes(r))),
    [roles]
  );
}



